// import { fromTwos } from "ethers";
import { axios } from "./axios";
// import { wlHttp } from "./wlHttp";
let http = axios;

// 获取网络列表
const getDappListApi = async (lang = "en") => {
  // await getHttp();
  return http.get(`/api/v1/store/items?lang=${lang}`);
};

// 用户接口 ---////////////////////////////////////////////////////*************

export { getDappListApi };
